export const nullDefault = (value) => value || null;
export const wait = (n) => new Promise((res) => setTimeout(res, n));
